export default __webpack_public_path__ + "static/gem-c001358728de339f49bd5fcc2b7442fc.jpg";